export default "__VITE_ASSET__CwOMYPzK__"